<template>
    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
          <div class="flex flex-wrap items-center">
            <vue-dropzone
              id="upload"
              ref="fileUploadZone"
              v-on:vdropzone-success="successSendFile"
              v-on:vdropzone-sending="sending"
              v-on:vdropzone-error="error"
              v-on:vdropzone-file-added="added"
              v-on:vdropzone-queue-complete="complete"
              :use-font-awesome="true"
              :options="dropzoneOptions"
              :use-custom-dropzone-options="true"
              :useCustomSlot="true"
              style="width: 100%; margin-bottom: 10px">
              <div class="dropzone-custom-content">
                <h3 class="dropzone-custom-title">
                  {{ $t('messages.drag_and_drop_image') }}
                </h3>
                <div class="subtitle">
                  {{ $t('messages.or_select_file_in_computer') }}
                </div>
                <div class="subtitle" v-if="hint">
                  {{ hint }}
                </div>
              </div>
            </vue-dropzone>
          </div>
          <div class="mt-2 w-full">
            <media-list :medias="imagesList"
                        :show-delete="true"
                        @deleteMedia="deleteImage"
                        :action-on-click="false" />
          </div>
      </div>
    </div>
</template>

<script>
import standard from '@/services/standard'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormGroup, BFormCheckbox, BInputGroupAppend, BInputGroup
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import MediaList from '@/components/media/MediaList.vue'


export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BInputGroupAppend,
    BInputGroup,
    // validations
    ValidationProvider,
    ValidationObserver,
    //
    MediaList, vueDropzone: vue2Dropzone,

  },
  props: {
    entityId: {
      type: Number,
      default: null
    },
    people_id: {
      type: Number,
      default: null
    },
    target:{
      type: String,
      default: null,
      required: true
    },
    serviceDelegate: {
      type: Function
    },
    imagesList:{
      type: Array,
      default: []
    },
    hint: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    id: null,
    dropzoneOptions: {},
    //imagesList: [],
    editMode: false,
    // validation rules
    required,
  }),
  computed: {

  },
  watch: {},
  methods: {
    clearFields() {

    },
    loadData() {

    },
    successSendFile(file, data) {
      this.imagesList.push(data)
      this.notifySuccess(this.$vs, this.$t('messages.success'))
      //remove file trash
      this.$refs.fileUploadZone.removeAllFiles()
    },
    deleteImage(media) {
      this.$vs.loading()

      this.serviceDelegate.deleteImage(this.entityId, media.id).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          //this.imagesList = data
          this.imagesList = this.imagesList.filter(element => {
              return element.id !== media.id
            })
        },
        error => {
          this.showErrors(this.$validator, error)
          this.notifyError(
            this.$vs,
            this.$t('messages.error')
          )
        }
      ).finally(
        () => { this.$vs.loading.close() }
      )
    },
  },
  beforeMount() {

    this.dropzoneOptions = {
      url: `${process.env.VUE_APP_API_BASE_URL}/api/v1/${this.target}/${this.entityId}/images`,
      thumbnailWidth: 150,
      addRemoveLinks: true,
      createImageThumbnails: true,
      timeout: 180000,
      //maxFiles: 1,
      headers: { Authorization: `Bearer ${standard.token()}` },
      acceptedFiles: 'image/jpeg,image/png,image/gif,image/jpg',
    }

  },
  beforeDestroy() {

  },
  mounted() {
    this.loadData()
  }
}
</script>
